export enum PlanType {
  Yearly = 'yearly',
  Monthly = 'monthly'
}
